export enum FormatoRelatorioEnum {

  PDF = "PDF",
  XLS = "XLS",
  CSV = "CSV"

}

